import io from "socket.io-client";

const CPF_CLIENT_DEV_HOST = 'localhost:8080';
const CPF_SERVER_DEV_HOST = 'localhost:8080';

const HOST_IN_DEV = process.env.VUE_APP_WS_URL;
const HOST_ON_PORT = window.location.host === CPF_CLIENT_DEV_HOST
    ? CPF_SERVER_DEV_HOST
    : window.location.host;

const config = {
    host: HOST_IN_DEV || HOST_ON_PORT,
};

export class Socket {
    constructor(config) {
        this.socket = io(config.host);
    }

    emit(eventName, data) {
        this.socket.emit(eventName, data);
    }

    on(eventName, handler) {
        this.socket.on(eventName, handler);
    }
}

export const socket = new Socket(config);
